import { render } from "./CarouselItem.vue?vue&type=template&id=4bea2142&scoped=true"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import "./CarouselItem.vue?vue&type=style&index=0&id=4bea2142&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bea2142"]])

export default __exports__